import { render, staticRenderFns } from "./SysConfigNew.vue?vue&type=template&id=5348fa9f&scoped=true"
import script from "./SysConfigNew.vue?vue&type=script&lang=js"
export * from "./SysConfigNew.vue?vue&type=script&lang=js"
import style0 from "./SysConfigNew.vue?vue&type=style&index=0&id=5348fa9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348fa9f",
  null
  
)

export default component.exports